module.exports = __webpack_public_path__ + "fonts/Montserrat-Thin.143850af.eot";